<!--
Author: TangChen
Date: 2019-02-25
Desc: 组合定投基金，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-combo-general bizcomp ' + className">
        <comp-title :title="title" />
        <fund-risk-filter :qryall="qryallfund" v-on:qry-change="qryChange" />
        <combo-list ref="comboList" :flag="flag" v-on:combo-list="getData" />
        <div class="combo-optional">
            想自定义基金组合定投？<span class="like-a" v-on:click.prevent="$router.push({name:'optionalgeneral'})">立即前往</span>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import comboList from "@/components/fund/comboList";
import fundRiskFilter from "@/components/form/fundRiskFilter";
export default {
    name: "ComboGeneral",
    components: {
        comboList,
        fundRiskFilter
    },
    mixins: [mixin],
    data () {
        return {
            selFund: [],
            url: "generalbuy",
            qryallfund: "",
            flag: "1" // 组合类型，定投
        };
    },
    mounted () {
        this.getComboFund();
    },
    methods: {
        getData (val) {
            let _this = this;
            val.proto = "buy";
            this.$util.fundRiskCheck(this, val, res => {
                if (res) {
                    const _x = Object.assign({}, res, { way: "59" });
                    sessionStorage.setItem(_this.url, JSON.stringify(_x));
                    _this.$router.push({ name: _this.url, query: { fundcode: res.fundcode } });
                }
            });
        },
        // 查询组合购买基金信息
        getComboFund () {
            const _this = this;
            const _x = {
                tradetype: this.flag,
                qryallfund: this.qryallfund
            };
            this.$util.request("trade/combine/fundlist", _x).then(res => {
                if (res.data) {
                    let _y = _this.$util.getCodeOnly(res.data[0], { code: "combinationcode", data: ["tano", "fundcode", "fundname", "comrate", "risklevel", "sharetype", "investkind", "investterm", "fundstatus"] }, ",");
                    _y.forEach(fund => {
                        fund.isBuy = this.$util.checkComboGeneral(fund);
                    });
                    _this.$refs.comboList.fundArr = _y;
                    _this.qryallfund = res.data[1][0].qryallfund;
                    const info = _this.$cache.getUser();
                    info.qryallfund = _this.qryallfund;
                    _this.$store.dispatch("setInfo", info);
                }
            });
        },
        // 改变风险过滤规则
        qryChange (val) {
            this.qryallfund = val;
            this.getComboFund();
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-combo-general {
    padding-bottom: 40px;
    .risk-filter-text {
        margin: 0;
        border: none;
        padding: 5px 10px;
    }
    .combo-optional {
        text-align: center;
        color: $text-color1;
        font-size: $f16;
        line-height: 40px;
    }
}
</style>
